import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const AuthService = {
    list: () => axios.post(API_URL + "/role/list").then(({ data }) => data).catch((err) => { throw err }),

    get: async (id) => axios.get(API_URL + "/role/get/roleById/" + id).then(({data}) => data).catch((err) => { throw err }),

    create: async (data) => axios.post(API_URL + "/role", data).then(({data}) => data).catch((err) => { throw err }),

    edit: async (id, data) => axios.post(API_URL + "/role/" + id, data).then(({data}) => data).catch((err) => { throw err }),

    delete: async (id) => axios.delete(API_URL + "/role/" + id).catch((err) => { throw err }),

    getByPermission: async () => axios.get(API_URL + "/role/get/byPermission").then(({data}) => data).catch(err => {throw err}),

    getAll: async () => axios.get(API_URL + "/role/get/allRoles").then(({data}) => data).catch(err => {throw err}),

    getPermissions: async () => axios.get(API_URL + "/role/get/permissions").then(({data}) => data.data).catch(err => {throw err}),

    dispatchDependencies: async (data) => axios.post(API_URL + "/role/get/dispatch-dependencies", data).then(({data}) => data).catch(err => {throw err}),

    lanes: async () => axios.get(API_KEEPER + "/lanes/web/restricted").then(({data}) => data).catch(err => {throw err}),

    maintenanceGroups: async () => axios.get(API_URL + "/role/get/maintenanceGroups").then(({data}) => data).catch(err => {throw err}),

    predefinedRoles: async () => axios.get(API_URL + "/role/get/predefined-roles").then(({data}) => data).catch(err => {throw err}),

    activeUsers: async () => axios.get(API_URL + "/role/get/active-users").then(({data}) => data).catch(err => {throw err}),

    permissionsByRoleId: async (data) => axios.post(API_URL + "/role/get/permissionsByRoleId", data).then(({data}) => data).catch(err => {throw err}),

    programs: async () => axios.get(API_KEEPER + "/sos/protection-program/all").then(({data}) => data).catch(err => {throw err})
};

export default AuthService;